import { Button as BaseButton, Typography } from 'radiance-ui';
import { SPACER } from 'radiance-ui/lib/constants';
import styled from '@emotion/styled';

export const Button = styled(BaseButton)`
  margin: ${SPACER.small} auto 0;
  width: 100%;

  & + & {
    margin-top: ${SPACER.small};
  }
`;

export const Heading = styled(Typography.Heading)`
  margin-bottom: ${SPACER.small};
  max-width: 100%;
`;
